import { FeedbackModal } from "@components/feedback-modal";
import { MobileBottomBar } from "@components/mobile-bottom-bar";
import { PopularManagementModal } from "@components/popular-management-modal";
import { SuggestionModal } from "@components/suggestion-modal";
import { UpgradeNeededModal } from "@components/upgrade-needed-modal";
import { useRedirectStripe } from "@features/user/use-billing";
import { ModelConsentModal } from "@views/app/camera/components/model-consent-modal";
import { LoraSearchModal } from "@views/app/lora/components/search-lora-modal";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import Header from "./header";

export const fullHeightValue = "var(--full-height-value)";

export const Page = ({
  verticalCenter,
  horizontalCenter,
  style,
  className,
  children,
}: {
  verticalCenter?: boolean;
  horizontalCenter?: boolean;
  style?: React.CSSProperties;
  className?: string;
  children: React.ReactNode;
}) => {
  return (
    <div
      className={twMerge(
        "flex",
        verticalCenter !== false && "items-center",
        horizontalCenter && "justify-center",
        className
      )}
      style={{ minHeight: fullHeightValue, ...style }}
    >
      <div className="h-max w-full">{children}</div>
    </div>
  );
};

let history: string[] = [];
export const getPreviousPath = () => {
  return history[history.length - 2] || "/";
};

export const usePageTitle = (title: string) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};

export const LayoutRouter = ({ redirect }: { redirect?: boolean }) => {
  // Initialize consent check
  useRedirectStripe();

  const { pathname } = useLocation();
  const { site } = useParams();
  useEffect(() => {
    if (pathname === history[history.length - 2]) {
      history.pop();
    } else if (pathname !== history[history.length - 1]) {
      history.push(pathname);
    }
    console.log(history);
  }, [pathname]);

  const navigate = useNavigate();
  useEffect(() => {
    if (
      redirect &&
      !["portraits", "showroom", "architect"].includes(site || "") &&
      !pathname.includes("/welcome")
    ) {
      navigate("/portraits/");
    }
  }, [redirect, site, navigate, pathname]);

  return (
    <Layout withSites={redirect}>
      <>
        <Outlet />
        <PopularManagementModal />
        <LoraSearchModal />
        <ModelConsentModal />
        <UpgradeNeededModal />
        <FeedbackModal />
        <SuggestionModal />
      </>
    </Layout>
  );
};

export const Layout = ({
  children,
  className,
  withSites,
}: {
  children: React.ReactNode;
  className?: string;
  withSites?: boolean;
}) => {
  // Initialize consent check
  const { pathname } = useLocation();

  // On page change: scroll to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div
      className={twMerge(
        "min-h-dvh w-full bg-white dark:bg-slate-950 md:pb-0",
        className
      )}
    >
      <Header withSites={withSites} />
      {children}
      {/* Spacer for mobile bottom bar */}
      <div className="h-16 md:h-0" />
      <MobileBottomBar />
    </div>
  );
};
